module.exports = __webpack_public_path__ + "static/media/tick.5c4cfd14.svg";